var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-row',{attrs:{"gutter":_vm.stats.rowSize}},_vm._l((_vm.stats.data),function(item){return _c('el-col',{attrs:{"span":_vm.stats.colSize}},[_c('el-statistic',{attrs:{"title":item.title}},[_c('template',{slot:"formatter"},[_vm._v(_vm._s(item.total))])],2)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }